module.exports = __webpack_public_path__ + "img/409.df4582a8.png";